/**
 * Almacenamiento de la firma de Migro (contratos y mandatos).
 * Se usa en Ajustes > Firma de Migro y al generar PDFs definitivos.
 */

export const MIGRO_SIGNATURE_STORAGE_KEY = 'migro_signature_global';

export function getMigroSignatureFromStorage(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(MIGRO_SIGNATURE_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setMigroSignatureInStorage(dataUrl: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (dataUrl == null) {
      localStorage.removeItem(MIGRO_SIGNATURE_STORAGE_KEY);
    } else {
      localStorage.setItem(MIGRO_SIGNATURE_STORAGE_KEY, dataUrl);
    }
  } catch (e) {
    console.warn('No se pudo guardar la firma de Migro:', e);
  }
}
